import { z } from 'zod';

// Define the schema for environment variables
const envSchema = z.object({
  REACT_APP_API_URL: z.string().url(),
  REACT_APP_ARTELIZE_URL: z.string().url(),
  REACT_APP_HUBSPOT_PORTAL_ID: z.string(),
  NODE_ENV: z.enum(['development', 'production', 'test']).optional(),
  // Add other environment variables here with appropriate validation
});

// Parse and validate environment variables
const env = envSchema.parse({
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_ARTELIZE_URL: process.env.REACT_APP_ARTELIZE_URL,
  REACT_APP_HUBSPOT_PORTAL_ID: process.env.REACT_APP_HUBSPOT_PORTAL_ID,
  NODE_ENV: process.env.NODE_ENV,
  // Add other environment variables here
});

export default env;
